<template>
  <el-main>
    <el-table :data="list" :header-cell-style="{ 'background-color': '#F8F9FA' }" row-key="id">
      <template slot="empty">
        <No />
      </template>
      <el-table-column prop="member_name" label="公司名称"  align="center"></el-table-column>
      <el-table-column prop="name" label="姓名"  align="center"></el-table-column>
      <el-table-column prop="mobile" label="手机"  align="center"></el-table-column>
      <el-table-column prop="type" label="需要建的小程序" width="200" align="center">
        <template v-slot="{ row }">
          {{ showType(row) }}
        </template>
      </el-table-column>
    </el-table>
    <Paging :total="total_number" :page="searchForm.page" :pageNum="searchForm.rows"></Paging>
  </el-main>
</template>

<script>
import Paging from '@/components/paging';
import _ from 'lodash';

export default {
  components: {
    Paging,
  },
  data() {
    return {
      searchForm: {
        page: 1,
        rows: 10,
      },
      list: [],
      total_number: 0,
      typeObj: {
        1: '微信小程序',
        2: '抖音小程序',
        3: '百度小程序',
        4: '支付宝小程序',
        5: '华为快应用',
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let searchForm = _.cloneDeep(this.searchForm);
      this.$axios.post(this.$api.gateway.service.miniProgramList, searchForm).then(res => {
        if (res.code === 0) {
          this.list = res.result.list;
          this.total_number = res.result.total_number;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    showType(row){
      let arr = row.type.toString().split(',');
      return arr.map(item=>this.typeObj[item]).join('、');
    }
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
}
</style>
